<template>
  <div class="users-window">
    <h1 class="page-header">Add Learner</h1>
    <div class="page-content-add-user">
      <b-field grouped>
        <b-field label="First Name" expanded>
          <b-input class="editBox input" v-model="firstName"></b-input>
        </b-field>
        <b-field label="Last Name" expanded>
          <b-input class="editBox input" v-model="lastName"></b-input>
        </b-field>
        <b-field label=" Preferred Name" expanded>
          <b-input class="editBox input" v-model="preferredName"></b-input>
        </b-field>
      </b-field>

      <b-field grouped>
        <b-field label="Email" expanded>
          <b-input type="email" class="editBox input" v-model="email"></b-input>
        </b-field>

        <b-field label="Student Number" expanded>
          <b-input
            type="text"
            class="editBox input"
            v-model="studentNumber"
            placeholder="field can be left blank"
          ></b-input>
        </b-field>
      </b-field>

      <b-field grouped>
        <b-field label="Grade">
          <b-select
            class="editBox row-selection"
            :placeholder="grades[0]"
            :disabled="grades.length === 0"
            v-model="learnerGrade"
          >
            <option
              v-for="(option, index) in grades"
              :value="option"
              :key="index"
            >
              {{
                option == 13
                  ? "Adult"
                  : contextualSpecificGradeAndLabelMin(option)
              }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Class" v-if="classes.length > 0">
          <b-select
            class="editBox"
            :placeholder="classes.length > 1 ? 'ALL' : classes[0]"
            :disabled="classes.length <= 0"
            v-model="currentClass"
          >
            <option :value="-1">
              ALL
            </option>
            <option
              v-for="(option, index) in classes"
              :value="option"
              :key="index"
            >
              {{ option }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Password">
          <b-input
            type="password"
            maxlength="30"
            class="input-border"
            password-reveal
            v-model="password"
          >
          </b-input>
        </b-field>
      </b-field>

      <b-field grouped>
        <b-field label="Add English?">
          <div class="is-justify-content-start">
            <b-checkbox native-value="Maths" v-model="addMaths">
              Maths
            </b-checkbox>

            <b-checkbox native-value="English" v-model="addEnglish">
              English
            </b-checkbox>
          </div>
        </b-field>

        <b-field class="lockJourney">
          <div class="is-flex-direction-column">
            <p class="toggleTitle">Enable lock Journey?</p>
            <b-switch
              class="toggleSwitch"
              v-model="isLockJourneyActive"
              true-value="Yes"
              false-value="No"
            >
            </b-switch>
          </div>

          <div
            class="is-justify-content-start new-lock-journey"
            v-if="isLockJourneyActive == 'Yes'"
          >
            <b-checkbox
              :disabled="catchup"
              v-model="assessment"
              native-value="assessment"
            >
              Assessment
            </b-checkbox>
            <b-checkbox
              :disabled="assessment"
              native-value="catchup"
              v-model="catchup"
            >
              Catchup
            </b-checkbox>
          </div>
        </b-field>

        
      </b-field>

      <b-field v-if="locales && locales.length > 0" label="Locale" style="margin-top:1.8rem">
        <b-select
          class="editBox row-selection"
          :disabled="locales.length === 0"
          v-model="learnerLocale"
        >
          <option
            v-for="locale in locales"
            :value="locale.code"
            :key="locale.id"
          >
            {{ locale.code }}
          </option>
        </b-select>
      </b-field>

      <b-field class="btn-spacing">
        <b-button
          id="btnAdd"
          @click="addLearner()"
          class="tag is-primary"
          size="is-large"
          >Add Learner</b-button
        >
      </b-field>
    </div>
  </div>
</template>

<style lang="scss">
@import "./styles/addUser.scss";
</style>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import localizationMixin from "@/modules/global/mixins/localizationMixin.js";

export default {
  data() {
    return {
      firstName: null,
      lastName: null,
      preferredName: null,
      email: null,
      studentNumber: null,
      learnerGrade: 0,
      currentGradeIndex: 0,
      currentClass: -1,
      password: null,
      addEnglish: false,
      addMaths: false,
      isLockJourneyActive: "No",
      grade: null,
      currentSchoolIndex: 0,
      subject: null,
      lockJourney: null,
      catchup: false,
      assessment: false,
      learnerLocale: null
    };
  },
  mixins: [localizationMixin],
  computed: {
    ...mapState({
      locales: state => state.globalStore.locales,
      filterValues: state => state.globalStore.filterLists,
      project: state => state.globalStore.activeFilterParams.project,
      filteredGrade: state => state.globalStore.activeFilterParams.grade,
      schoolIndex: state => state.globalStore.activeFilterParams.school,
      isInternal: state => state.globalStore.settings.isInternal
    }),
    ...mapGetters({
      getCurrentSchoolIndex: "globalStore/getCurrentSchoolIndex",
      getCurrentGradeIndex: "globalStore/getCurrentGradeIndex",
      getSchoolName: "globalStore/getSchoolName"
    }),
    schools() {
      if (this.project && this.filterValues.schools.filterBy) {
        const orderBySchool = this.filterValues.schools.value.map(
          schoolObject => schoolObject
        );

        //ordering the scools by alphabetical order
        const sortedBySchool = sortBy => (a, b) =>
          a[sortBy] > b[sortBy] ? 1 : -1;
        orderBySchool.sort(sortedBySchool("school"));
        return orderBySchool;
      }
      return null;
    },
    grades() {
      if (this.schools && this.schools[this.currentSchoolIndex]) {
        return Object.keys(this.schools[this.currentSchoolIndex].grades).map(
          grade => {
            return grade;
          }
        );
      } else if (this.filterValues.tutors.filterBy) {
        return ["3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
      }
      return [];
    },
    classes() {
      if (
        this.schools &&
        this.schools[this.currentSchoolIndex].grades[this.learnerGrade]
      ) {
        return this.schools[this.currentSchoolIndex].grades[this.learnerGrade]
          .classes;
      }
      return [];
    },
    selectedSchool() {
      return this.schools[this.currentSchoolIndex].school
    }
  },
  methods: {
    ...mapActions({
      addLearnerToProject: "adminStore/addLearnerToProject",
      fetchLocales: "globalStore/fetchLocales",
      loading: "SET_SCREEN_LOADING"
    }),
    async addLearner() {
      this.lockJourney = "";
      //lockedJourneys
      if (this.catchup || this.assessment) {
        if (this.catchup) {
          this.lockJourney = "catchup";
        }
        if (this.assessment) {
          this.lockJourney = "assessment";
        }
      }

      //adding english
      if (this.addEnglish) {
        this.subject = "ENGLISH";
      }

      //adding maths
      if (this.addMaths) {
        this.subject = "MATHS";
      }

      //add both english and math
      if (this.addMaths && this.addEnglish) {
        this.subject = "MATHS|ENGLISH";
      }

      const learner = this.addClassToLearner(this.currentClass);

      if (
        this.firstName == null ||
        this.lastName == null ||
        this.preferredName == null ||
        this.email == null ||
        this.learnerGrade == 0 ||
        this.subject == null ||
        this.password == null ||
        this.learnerLocale == null
      ) {
        this.$buefy.toast.open({
          message: "Please provide all the required fields",
          type: "is-danger",
          duration: 4500
        });
      } else {
        if (
          !(this.password.trim() === "") &&
          !(this.password.trim().length < 6)
        ) {
          this.loading(true);
          let request = await this.addLearnerToProject(learner);
          this.loading(false);

          if (request.submitted) {
            this.$buefy.toast.open({
              message: request.message,
              type: "is-success",
              duration: 4500
            });
            //clearing inputs fields.
            this.firstName = null;
            this.lastName = null;
            this.preferredName = null;
            this.email = null;
            this.studentNumber = null;
            this.password = null;
            this.addEnglish = false;
            this.learnerLocale= null;
            this.isLockJourneyActive = "No";
          } else {
            this.$buefy.toast.open({
              message: request.message,
              type: "is-danger",
              duration: 4500
            });
          }
        } else {
          this.$buefy.toast.open({
            message: "Password must be more than 5 characters.",
            type: "is-danger",
            duration: 4000
          });
        }
      }
    },
    addClassToLearner(addClass) {
      if (addClass != -1) {
        return {
          firstName: this.firstName,
          lastName: this.lastName,
          preferredName: this.preferredName,
          grade: this.learnerGrade,
          class: this.currentClass,
          email: this.email,
          studentNumber: this.studentNumber,
          password: this.password,
          project: this.project,
          school: this.selectedSchool,
          subject: this.subject,
          lockedJourneys: this.lockJourney,
          locale: this.learnerLocale
        };
      } else {
        return {
          firstName: this.firstName,
          lastName: this.lastName,
          preferredName: this.preferredName,
          grade: this.learnerGrade,
          email: this.email,
          studentNumber: this.studentNumber,
          password: this.password,
          project: this.project,
          school: this.selectedSchool,
          subject: this.subject,
          lockedJourneys: this.lockJourney,
          locale: this.learnerLocale
        };
      }
    },
    addToGradesArray(min, max, array, result) {
      array.forEach(element => {
        if (element >= min && element <= max) {
          result.push(element);
        }
      });
      return true;
    }
  },
  created() {
    this.fetchLocales();
  },
  mounted() {
    this.currentSchoolIndex = this.getCurrentSchoolIndex;
    this.currentGradeIndex = this.getCurrentGradeIndex;
  },
  watch: {
    getCurrentSchoolIndex(value) {
      this.currentSchoolIndex = value;
    }
  }
};
</script>
